import { useEffect, useState } from 'react';
import { $getSelection, $isRangeSelection } from 'lexical';

export function useEditorSelection(editor) {
  const [selection, setSelection] = useState(null);

  useEffect(() => {
    if (!editor) {
      return undefined;
    }

    return editor.registerUpdateListener(({ editorState }) => {
      editorState.read(() => {
        const currentSelection = $getSelection();
        if ($isRangeSelection(currentSelection) && !currentSelection.isCollapsed()) {
          setSelection({
            text: currentSelection.getTextContent(),
            anchorKey: currentSelection.anchor.key,
            anchorOffset: currentSelection.anchor.offset,
            focusKey: currentSelection.focus.key,
            focusOffset: currentSelection.focus.offset,
          });
        } else {
          setSelection(null);
        }
      });
    });
  }, [editor]);

  return selection;
}
